import styled, { keyframes, css } from 'styled-components';

export const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const ModelStatusWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 25px;
`;

export const StepWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-left: ${({ isFirst }) => (isFirst ? '10%' : '0')};
`;

export const IconWrapper = styled.div`
	position: relative;
	width: 50%;
	aspect-ratio: 1;
	flex-shrink: 0;
`;

export const SpinningBorder = styled.div`
	position: absolute;
	top: -2px;
	left: -2px;
	width: calc(100% + 4px);
	height: calc(100% + 4px);
	border-radius: 50%;
	${({ isActive, status }) =>
		isActive &&
		status === 6 &&
		css`
			border: 4px solid lightgray;
			border-top-color: #ffaf02;
			animation: ${spin} 1.5s linear infinite;
		`};
`;

export const IconContainer = styled.div`
	width: 100%;
	height: 100%;
	border-radius: 50%;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	filter: ${({ isGrayscale }) => (isGrayscale ? 'grayscale(100%)' : 'none')};
	border: ${({ isFailed }) => (isFailed ? '2px solid red' : 'none')};
`;

export const StatusImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const ConnectingLine = styled.div`
	border-bottom: 3px dotted ${({ isPending }) => (isPending ? 'lightgrey' : '#ffaf02')};
	width: 100%;
	margin: 0 5px;
`;
